'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { Networks } from 'AdsUI/lib/Constants';
import { fetchTrackingStatusesForCampaign } from 'AdsUI/data/TrackingStatusData';
import useTrackingErrorModal from 'AdsUI/lib/useTrackingErrorModal';
import BaseTrackingErrorModal from 'AdsUI/components/tracking-error-modal/BaseTrackingErrorModal';

const CampaignTrackingErrorModal = ({
  accountId,
  campaignId,
  name,
  network,
  onClose
}) => {
  const fetchStatuses = useCallback(() => fetchTrackingStatusesForCampaign(network, accountId, campaignId), [network, accountId, campaignId]);
  const {
    loading,
    groupedStatuses
  } = useTrackingErrorModal(fetchStatuses);
  return /*#__PURE__*/_jsx(BaseTrackingErrorModal, {
    onClose: onClose,
    groupedStatuses: groupedStatuses,
    loading: loading,
    name: name
  });
};

CampaignTrackingErrorModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  campaignId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  network: PropTypes.oneOf(Object.keys(Networks)).isRequired,
  onClose: PropTypes.func.isRequired
};
export default CampaignTrackingErrorModal;